// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"375e8165","31":"51e1bcbe","312":"8e2d67f4","453":"94b41bd7","626":"f0c963c9","960":"c84c0089","981":"0b033c2e"}[chunkId] + ".chunk.js";
};